// Redux
import { Dispatch } from "redux";

// Classes
import { AgeReducerState } from "../Age/classes/age.classes";
import { EthnicityReducerState } from "../Ethnicity/classes/ethnicity.classes";
import { GenderReducerState } from "../Gender/classes/gender.classes";
import { GeographyReducerState } from "../Geography/classes/geography.classes";
import { VisitorTypeReducerState } from "../VisitorType/classes/visitorType.classes";

// Actions
import { initializeAgeState } from "../Age/actions/age.actions";
import { initializeEthnicityState } from "../Ethnicity/actions/ethnicity.actions";
import { initializeGenderState } from "../Gender/actions/gender.actions";
import { initializeGeographyState } from "../Geography/actions/geography.actions";
import { initializeVisitorTypeState } from "../VisitorType/actions/visitorType.actions";

export const initializeDemographicsState = (
  dispatch: Dispatch<any>,
  ageReducerState: AgeReducerState,
  ethnicityReducerState: EthnicityReducerState,
  genderReducerState: GenderReducerState,
  geographyReducerState: GeographyReducerState,
  visitorTypeReducerState: VisitorTypeReducerState
) => {
  initializeAgeState(dispatch, ageReducerState);
  initializeEthnicityState(dispatch, ethnicityReducerState);
  initializeGenderState(dispatch, genderReducerState);
  initializeGeographyState(dispatch, geographyReducerState);
  initializeVisitorTypeState(dispatch, visitorTypeReducerState);
};
